import { useState } from 'react';

export default function Menu() {
  const [activeCategory, setActiveCategory] = useState('breakfast');

  const menuData = {
    breakfast: [
      {
        name: 'スーパーフードアサイーボウル',
        price: '¥1,480',
        description: 'オーナーのおすすめ！アサイー、バナナ、グラノーラ、フレッシュフルーツ',
        image: 'https://public.readdy.ai/ai/img_res/1a6108b47a4bbd039ffd1436414dc2cc.jpg',
        recommended: true
      },
      {
        name: '湘南フィッシュプレート',
        price: '¥1,680',
        description: '地元で獲れた新鮮な魚のグリル、季節野菜、玄米ご飯',
        image: 'https://readdy.ai/api/search-image?query=Grilled%20fresh%20fish%20plate%20with%20seasonal%20vegetables%20and%20brown%20rice%2C%20Japanese%20coastal%20cuisine%2C%20healthy%20lunch%20meal%2C%20beautiful%20plating%20on%20white%20dish%2C%20professional%20food%20photography%2C%20natural%20lighting%2C%20simple%20clean%20background&width=600&height=400&seq=menu-fish-001&orientation=landscape'
      },
      {
        name: 'サーファーズブレックファスト',
        price: '¥1,280',
        description: 'スクランブルエッグ、アボカド、全粒粉トースト、サラダ',
        image: 'https://readdy.ai/api/search-image?query=Healthy%20breakfast%20plate%20with%20scrambled%20eggs%2C%20avocado%2C%20whole%20grain%20toast%2C%20fresh%20salad%2C%20nutritious%20morning%20meal%2C%20professional%20food%20photography%2C%20bright%20natural%20lighting%2C%20simple%20clean%20background&width=600&height=400&seq=menu-breakfast-001&orientation=landscape'
      },
      {
        name: 'オーガニックパンケーキ',
        price: '¥1,180',
        description: 'ふわふわパンケーキ、メープルシロップ、季節のフルーツ',
        image: 'https://readdy.ai/api/search-image?query=Fluffy%20organic%20pancakes%20with%20maple%20syrup%20and%20fresh%20seasonal%20fruits%2C%20berries%20on%20top%2C%20beautiful%20breakfast%20presentation%2C%20professional%20food%20photography%2C%20natural%20lighting%2C%20simple%20clean%20background&width=600&height=400&seq=menu-pancake-001&orientation=landscape'
      }
    ],
    drinks: [
      {
        name: 'オーガニックブレンドコーヒー',
        price: '¥580',
        description: '厳選されたオーガニック豆を使用した深煎りブレンド',
        image: 'https://readdy.ai/api/search-image?query=Cup%20of%20organic%20blend%20coffee%20in%20white%20ceramic%20cup%2C%20rich%20dark%20roast%2C%20beautiful%20latte%20art%2C%20professional%20beverage%20photography%2C%20natural%20lighting%2C%20simple%20clean%20background%2C%20cafe%20atmosphere&width=600&height=400&seq=menu-coffee-001&orientation=landscape'
      },
      {
        name: 'シーサイドスムージー',
        price: '¥780',
        description: 'マンゴー、パイナップル、ココナッツミルクの南国風スムージー',
        image: 'https://readdy.ai/api/search-image?query=Tropical%20smoothie%20with%20mango%2C%20pineapple%2C%20coconut%20milk%20in%20tall%20glass%2C%20vibrant%20yellow%20color%2C%20fresh%20fruit%20garnish%2C%20professional%20beverage%20photography%2C%20natural%20lighting%2C%20simple%20clean%20background&width=600&height=400&seq=menu-smoothie-001&orientation=landscape'
      },
      {
        name: 'オーガニックハーブティー',
        price: '¥680',
        description: 'カモミール、ペパーミント、レモングラスから選べます',
        image: 'https://readdy.ai/api/search-image?query=Organic%20herbal%20tea%20in%20glass%20teapot%20and%20cup%2C%20fresh%20herbs%2C%20calming%20and%20relaxing%20beverage%2C%20professional%20photography%2C%20natural%20lighting%2C%20simple%20clean%20background%2C%20peaceful%20atmosphere&width=600&height=400&seq=menu-tea-001&orientation=landscape'
      },
      {
        name: 'フレッシュジュース',
        price: '¥680',
        description: 'オレンジ、グレープフルーツ、キャロット＆アップル',
        image: 'https://readdy.ai/api/search-image?query=Fresh%20squeezed%20fruit%20juice%20in%20glass%2C%20orange%20and%20grapefruit%2C%20vibrant%20colors%2C%20healthy%20beverage%2C%20professional%20photography%2C%20natural%20lighting%2C%20simple%20clean%20background&width=600&height=400&seq=menu-juice-001&orientation=landscape'
      }
    ],
    sweets: [
      {
        name: 'ココナッツチーズケーキ',
        price: '¥780',
        description: '濃厚なチーズケーキにココナッツの風味をプラス',
        image: 'https://readdy.ai/api/search-image?query=Coconut%20cheesecake%20slice%20on%20white%20plate%2C%20creamy%20texture%2C%20tropical%20dessert%2C%20professional%20food%20photography%2C%20natural%20lighting%2C%20simple%20clean%20background%2C%20elegant%20presentation&width=600&height=400&seq=menu-cheesecake-001&orientation=landscape'
      },
      {
        name: 'シーソルトブラウニー',
        price: '¥680',
        description: 'ほろ苦いチョコレートと海塩の絶妙なハーモニー',
        image: 'https://readdy.ai/api/search-image?query=Sea%20salt%20brownie%20with%20chocolate%2C%20rich%20and%20decadent%20dessert%2C%20professional%20food%20photography%2C%20natural%20lighting%2C%20simple%20clean%20background%2C%20gourmet%20presentation&width=600&height=400&seq=menu-brownie-001&orientation=landscape'
      },
      {
        name: 'マンゴータルト',
        price: '¥880',
        description: 'フレッシュマンゴーをたっぷり使った季節限定タルト',
        image: 'https://readdy.ai/api/search-image?query=Fresh%20mango%20tart%20with%20custard%20cream%2C%20tropical%20fruit%20dessert%2C%20beautiful%20presentation%20on%20white%20plate%2C%20professional%20food%20photography%2C%20natural%20lighting%2C%20simple%20clean%20background&width=600&height=400&seq=menu-tart-001&orientation=landscape'
      }
    ]
  };

  const categories = [
    { id: 'breakfast', label: 'BREAKFAST & LUNCH', time: '11:00-15:00' },
    { id: 'drinks', label: 'DRINK & CAFE', time: 'All Day' },
    { id: 'sweets', label: 'SWEETS', time: 'All Day' }
  ];

  return (
    <section id="menu" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            MENU
          </h3>
          <div className="w-24 h-1 bg-blue-500 mx-auto"></div>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === category.id
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <div>{category.label}</div>
              <div className="text-xs mt-1 opacity-80">{category.time}</div>
            </button>
          ))}
        </div>

        {/* Menu Items */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {menuData[activeCategory as keyof typeof menuData].map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow relative"
            >
              {item.recommended && (
                <div className="absolute top-4 right-4 bg-yellow-400 text-gray-900 px-4 py-2 rounded-full text-sm font-bold z-10 shadow-lg">
                  おすすめ！
                </div>
              )}
              <div 
                className="h-64 bg-cover bg-center"
                style={{ backgroundImage: `url(${item.image})` }}
              ></div>
              <div className="p-6">
                <div className="flex justify-between items-start mb-3">
                  <h4 className="text-xl font-bold text-gray-900">{item.name}</h4>
                  <span className="text-2xl font-bold text-blue-600 whitespace-nowrap ml-4">
                    {item.price}
                  </span>
                </div>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}